// @flow

import { gql } from "@apollo/client";
import { graphql } from "@apollo/client/react/hoc";
import { fragments as transfersUVOrderStatusFragments } from "../../application/apps/TransferPrintingApp/components/TransfersUVOrderStatus/graph";

const markOrderAsTransfersUVManualRippingStarted: any = graphql(
  gql`
    mutation($orderId: ID!) {
      markOrderAsTransfersUvManualRippingStarted(orderId: $orderId) {
        errors {
          orderId
        }
        updatedOrder {
          ...TransfersUVOrderStatus_order
        }
        succeeded
      }
    }
    ${transfersUVOrderStatusFragments.order}
  `,
  {
    name: "markOrderAsTransfersUVManualRippingStarted"
  }
);

export default markOrderAsTransfersUVManualRippingStarted;
